import styled from 'styled-components'
import { Link } from 'react-router-dom'
import useTranslation from '../../hooks/useTranslation'
import { widgetFont } from './widgetTypography'

/*
 * The link at a widget's top right to the full list behind it — the same on a
 * list card as on a chart card, so one dashboard has one way of saying it.
 */
const ViewAllLink = styled(Link)`
    flex-shrink: 0;
    ${widgetFont.label}
    color: ${p => p.theme.font.highlight};
    text-decoration: none;
    padding: 0.15rem 0.25rem;
    border-radius: 0.375rem;
    white-space: nowrap;

    &:hover { text-decoration: underline; }
    &:focus-visible { outline: 2px solid ${p => p.theme.font.highlight}; outline-offset: 1px; }
`

const ViewAll = ({ to, className }) => {
    const { t } = useTranslation()
    return <ViewAllLink to={to} className={className}>{t('analytics.viewAll')}</ViewAllLink>
}

export default ViewAll
